/**
 * Condition gate — WHEN a condition has to be satisfied.
 *
 * This is a separate axis from `requirementType` (which now only answers
 * "does this need a document?"). Stored on the condition as `conditionGate`.
 *
 * NOTE: `conditionGate` is not on the backend `UnderwritingRequirement` model
 * yet. `LOSBase` is `extra='allow'` so the value persists on write, but nothing
 * server-side validates or reads it until the field is added.
 */

export const CONDITION_GATE = {
  PRIOR_TO_DOCS: "Prior to Docs",
  PRIOR_TO_FUNDING: "Prior to Funding",
  POST_CLOSE: "Post Close",
};

/**
 * `label` is the full wording shown in the form toggle, the dropdown and detail
 * rows. `shortLabel` is the abbreviation, for space-constrained chips/columns.
 */
export const CONDITION_GATE_OPTIONS = [
  {
    value: CONDITION_GATE.PRIOR_TO_DOCS,
    label: "Prior to Docs",
    shortLabel: "PTD",
  },
  {
    value: CONDITION_GATE.PRIOR_TO_FUNDING,
    label: "Prior to Funding",
    shortLabel: "PTF",
  },
  {
    value: CONDITION_GATE.POST_CLOSE,
    label: "Post Close",
    shortLabel: "Post Close",
  },
];

export const CONDITION_GATE_VALUES = CONDITION_GATE_OPTIONS.map((o) => o.value);

/** Stored value → full label (Prior to Docs / Prior to Funding / Post Close). */
export const getConditionGateLabel = (gate) =>
  CONDITION_GATE_OPTIONS.find((o) => o.value === gate)?.label || gate || null;

/** Stored value → abbreviation (PTD / PTF / Post Close), for chips + columns. */
export const getConditionGateShortLabel = (gate) =>
  CONDITION_GATE_OPTIONS.find((o) => o.value === gate)?.shortLabel ||
  gate ||
  null;
